import $ from 'jquery'
//import 'bootstrap/js/dist/dropdown'

const showClass = 'show'

function openDropdown($container) {
  const $toggle = $container.find('.dropdown-toggle')
  const $dropdownMenu = $container.find('.dropdown-menu')

  if (!$dropdownMenu.length) {
    return
  }

  $container.addClass(showClass)
  $toggle.attr('aria-expanded', 'true')
  $dropdownMenu.addClass(showClass)

  const winWidth = document.documentElement.clientWidth || document.body.clientWidth
  const bounds = $dropdownMenu[0].getBoundingClientRect()
  if (bounds.right > winWidth) {
    const delta = bounds.right - winWidth
    $dropdownMenu.css('transform', `translateX(-${delta}px)`)
  }
}

function closeDropdown($container) {
  const $toggle = $container.find('.dropdown-toggle')
  const $dropdownMenu = $container.find('.dropdown-menu')
  $container.removeClass(showClass)
  $toggle.attr('aria-expanded', 'false')
  $dropdownMenu.removeClass(showClass)
  $dropdownMenu.css('transform', '')
}

function toggleDropdown($toggle) {
  const $container = $toggle.parent()
  if ($container.hasClass(showClass)) {
    closeDropdown($container)
  } else {
    openDropdown($container)
  }
}

const $doc = $(document)

$doc.on('click', '.nav .dropdown-toggle', (ev) => {
  const $target = $(ev.currentTarget)
  if ($target.prop('tagName') === 'A' && $target.closest('.nav').length) {
    document.location.href = $target.attr('href')
  }
})

$doc.on('keydown', '.nav .dropdown-toggle', (ev) => {
  const $target = $(ev.currentTarget)
  if (ev.key === 'Enter' && $target.prop('tagName') === 'A') {
    return true
  }
  if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'ArrowDown') {
    // Close all dropdowns
    const $nav = $(ev.currentTarget).closest('.nav')
    if ($nav.length) {
      closeDropdown($nav)
    }
    // Then toggle current dropdown
    const $dropdown = $(ev.currentTarget).parent().find('.dropdown-menu')
    if ($dropdown.length) {
      toggleDropdown($target)
      ev.preventDefault()
      return false
    }
  }
  return true
})

$doc.on('mouseenter', '.dropdown', (ev) => {
  const $container = $(ev.currentTarget)
  $container.data('has-mouse', true)
  openDropdown($container)
})

$doc.on('mouseleave', '.dropdown', (ev) => {
  const $container = $(ev.currentTarget)
  $container.data('has-mouse', false)

  let closeTimer = null
  const resetTimer = () => {
    clearTimeout(closeTimer)
    closeTimer = setTimeout(() => {
      if ($container.data('has-mouse') === true) {
        clearTimeout(closeTimer)
        return
      }
      closeDropdown($container)
    }, 250)
  }

  resetTimer()
})
